import { major } from 'semver';

class LoadedDependenciesMap {
    constructor(loadedSharedDependencies = {}) {
        this.loadedSharedDependencies = loadedSharedDependencies || {};
    }
    getLoadedVersion({ packageName, version, dependencies }) {
        const major$1 = major(version);
        const uniqueMajorString = buildMajorVersionsConcatenationString({ packageName, major: major$1, dependencies });
        return this.loadedSharedDependencies[uniqueMajorString];
    }
    /**
     * @param {SharedDepDetails} details - marks a shared dependency as loaded, with the specified sub dependencies that it has.
     */
    setLoadedVersion({ packageName, version, dependencies }) {
        const major$1 = major(version);
        const uniqueMajorString = buildMajorVersionsConcatenationString({ packageName, major: major$1, dependencies });
        this.loadedSharedDependencies[uniqueMajorString] = version;
    }
    serialize() {
        return JSON.stringify(this.loadedSharedDependencies);
    }
}
function buildMajorVersionsConcatenationString({ packageName, major, dependencies = {}, }) {
    const depsStr = Object.keys(dependencies)
        .sort((aValue, bValue) => aValue.localeCompare(bValue))
        .reduce((acc, depsPackageName) => `${acc}${depsPackageName}-${dependencies[depsPackageName]}`, '');
    return `${depsStr}${packageName}-${major}`;
}

export { buildMajorVersionsConcatenationString, LoadedDependenciesMap as default };
